export default "__VITE_ASSET__BPjAnteT__"